<template>
    <v-list two-line style="max-height: 275px; min-height: 275px;" class="overflow-y-auto">
        <v-list-item-group v-model="selectedResources" multiple active-class="pink--text">
            <div class="text-center" style="margin-bottom: 3px;">{{ this.selectedResources.length }} selected Ressources</div>
            <div class="text-center" style="margin-bottom: 6px; color: red;">
                <template v-for="(item1) in selectedResources3LetterCodes">
                    {{ item1 }}&nbsp;
                </template>
            </div>

            <template v-for="(item, index) in get_AllEmployees">
                <v-list-item :key="item.id" :value="item.id">
                    <template v-slot:default="{}">
                        <v-list-item-icon>
                            <v-icon>mdi-account-circle</v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                            <v-list-item-title>
                                <span style="font-size: 16px;">{{ item.genLastname.trim() }}, {{ item.genFirstName.trim() }} ({{ item.contractFunction }})</span>
                                <span style="font-size: 12px;">&nbsp;&nbsp;&nbsp;Last Release: {{ item.lastDutyPlanRelease }}</span>
                            </v-list-item-title>
                        </v-list-item-content>
                    </template>
                </v-list-item>

                <v-divider v-if="index + 1 < get_AllEmployees.length" v-bind:key="'div_' + index"></v-divider>
            </template>
        </v-list-item-group>
    </v-list>
</template>

<script>
    import { mapGetters } from 'vuex';
    // import { eventBus } from '../../../../main';


    export default {
        name : 'AllEmployeesList',

        /* >>> *************************************************************** / /* Props */
        props : {
        }, // eo props
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
        created: function() {

            let me = this;


            me.$toc('>>> views/shared/components/AllEmployeesList.vue >>> created');

        }, // eo created()


        /***********************************************************************
        * Lifecyclehook::mounted
        *
        * Desc:
        * Note: Select all.
        *
        */
        mounted: function() {

            let me = this;


            me.$toc('>>> views/shared/components/AllEmployeesList.vue >>> mounted');
            this.on_selectAll();

        }, // eo mounted()


        /***********************************************************************
        * Lifecyclehook::beforeDestroy
        *
        * Desc: Destroy Listener.
        * Note: No need to reset something here.
        *
        */
        beforeDestroy: function() {

            let me = this;


            me.$toc('>>> views/shared/components/AllEmployeesList.vue >>> beforeDestroy');

        }, // eo function beforeDestroy()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data() {

            return {
                selectedResources: [], // selected Resources
                selectedResources3LetterCodes: [], // selected Resources 3 Letter Codes
            };

        }, // eo data
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Watch */
        watch: {

            selectedResources(value) {

                this.$emit('input', value);

            }, // eo selectedResources()

        }, // eo watch
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'get_AllEmployees',
                'get_selectedMultiResources',
            ]),

        }, // eo computed
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * on_selectAll()
            *
            * Desc: Select all Resources.
            * Note: Ressources can be 'preSelected' in Table.
            *
            */
            on_selectAll: function(){

                let me = this,
                    allResources = [],
                    allResources3LetterCodes = [];


                me.$toc('>>> views/shared/components/AllEmployeesList.vue >>> on_selectAll');
                return; // retutn is only tmp here

                if (this.get_selectedMultiResources.length === 0) {
                    this.get_AllEmployees.forEach((item) => {
                        allResources.push(item.id);
                    });
                    this.selectedResources = [...allResources];
                }


                if (this.get_selectedMultiResources.length > 0) {
                    this.get_selectedMultiResources.forEach((item) => {
                        allResources.push(item.id);
                        allResources3LetterCodes.push(item.contract3Code);
                    });
                    this.selectedResources = [...allResources];
                    this.selectedResources3LetterCodes = [...allResources3LetterCodes];
                }

            }, // eo function on_selectAll

        } // eo methods
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
    .v-card .v-divider {
        border-color: #d2d2d2;
    }

    .v-list-item {
        padding: 0 26px;
    }

    .v-list--two-line .v-list-item, .v-list-item--two-line {
        min-height: 45px;
        max-height: 45px;
    }
</style>